import { z } from 'zod';
import { cohortTypeZodEnum } from '../../enum';

export const exportParticipantsReqDto = z.object({
  cohortIds: z.array(z.string()).default([]),
  cohortTypes: z.array(cohortTypeZodEnum()).default([]),
});

export type ExportParticipantsReqDto = z.infer<typeof exportParticipantsReqDto>;
